<label class="relative flex w-full items-center">
  <span class="sr-only">{{ placeholder() }}</span>
  <mat-icon
    svgIcon="search"
    class="pointer-events-none absolute left-2.5 !h-4 !w-4 text-tertiary"
  ></mat-icon>
  <input
    type="search"
    [formControl]="control"
    [placeholder]="placeholder()"
    [class]="
      variant() === 'global'
        ? 'h-9 w-full min-w-64 rounded-md border border-strong bg-surface pr-8 pl-8 text-body text-primary placeholder:text-tertiary focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none'
        : 'h-9 w-full min-w-72 rounded-md border border-strong bg-surface pr-8 pl-8 text-body text-primary placeholder:text-tertiary focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none'
    "
  />
  @if (control.value) {
    <button
      type="button"
      class="absolute right-2 flex h-5 w-5 items-center justify-center rounded-full hover:bg-hover"
      (click)="clear()"
      aria-label="Limpiar búsqueda"
    >
      <mat-icon svgIcon="x" class="!h-3.5 !w-3.5 text-tertiary"></mat-icon>
    </button>
  }
</label>
